import { useAuth } from "@clerk/clerk-react";
import { useCallback } from "react";
import { setClerkTokenGetter } from "./createAuthedAxios";

export function ClerkTokenBridge() {
  const { getToken, isLoaded, isSignedIn } = useAuth();
  const getReadyToken = useCallback(async (opts?: { forceRefresh?: boolean }) => {
    if (!isLoaded || !isSignedIn) return null;
    return getToken(opts?.forceRefresh ? { skipCache: true } : undefined);
  }, [getToken, isLoaded, isSignedIn]);

  // Set synchronously during render so the interceptor has a token getter
  // before any child useEffect fires (avoids the one-render timing gap).
  setClerkTokenGetter(getReadyToken);
  return null;
}
